import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./keyra/tokens.css";

const ownerRoute = location.pathname === "/control-centre" || location.pathname.startsWith("/control-centre/");
const investorDeckRoute = location.pathname === "/investor-deck" || location.pathname.startsWith("/investor-deck/");
const root = createRoot(document.getElementById("root")!);
if (investorDeckRoute) void import("./InvestorDeck").then(({ default: InvestorDeck }) => root.render(<InvestorDeck/>));
else if (ownerRoute) void import("./OwnerControlCentre").then(({ default: OwnerControlCentre }) => root.render(<StrictMode><OwnerControlCentre/></StrictMode>));
else void import("./keyra/PublicApp").then(({ default: PublicApp }) => root.render(<StrictMode><PublicApp/></StrictMode>));
